// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1p0DK","withIndication":"Icon_withIndication__2VaWx"};